export function createFormSubmitEvent(payload) {
    return new CustomEvent("d365mkt-formsubmit", { bubbles: true, cancelable: true, detail: { payload: payload } });
}
